import { sendResultsFilters } from './results-api';
import { setDataBuilder } from '../../builder-filter';
import { loadMoreResults } from '../script';
import { loadFiltersSlider, bindRangeInputs } from '../filters/sliderRange';
import { adjustColor } from './results-ui';
import { loadData } from './load';
export async function loadBuilderData() {
    window.rangeValueBuilder = 12;
    const sendData = await sendResultsFilters(true);
    loadData(true);
    setDataBuilder(sendData);
    loadMoreResults(true, true);
    requestAnimationFrame(() => {
        loadFiltersSlider('precio_builder');
        bindRangeInputs('precio_builder');
        loadBannerBuilder();
    });
}
export function loadBannerBuilder() {
    let contentCards = document.querySelectorAll('.fair-card--builder');
    contentCards.forEach((card) => {
        const bannerBuilderFair = card.querySelector('.fair-card__banner--builder');
        if (bannerBuilderFair) {
            const baseColor = bannerBuilderFair.getAttribute('base-color');
            if (baseColor) {
                const adjustedColor = adjustColor(baseColor);
                bannerBuilderFair.style.background =
                    `linear-gradient(45deg, ${baseColor} 0%, ${adjustedColor} 100%)`;
            }
        }
    });
}
